<template>
  <div v-if="loaded">
    <div v-if="!$root.sub" class="productcompact productcompactWhite productbuy" :data-productpriceid="id" @mouseenter="showProductImagesOnClick">
      <div class="priceWrap">
        <div class="productquantity clearfix">
          <p>{{strippedQuant}}</p>
        </div>
        <div class="productprice" style="padding-right: 8px;">
          <p v-if="prices.price != 'NaN' && !hidePrice" v-html="getVisString(prices.price)"></p>
        </div>
        <additionalInfo v-if="(prices.discount > 0 || this.$root.iscompany == 1)" :data="prices" :companyPriceIncludingVat="getVisString(prices.companyPriceIncludingVat)" :listPrice="getVisString(prices.listPrice)" :localDiscount="getVisString(prices.discount)"
          :tax="tax" :showBuyButton="true" />        
      </div>     
      
      <PromotionLabel :promotion="prices.promotionAttributes" v-if="prices.promotionAttributes && prices.promotionAttributes.length > 0"/>
 
      <buybutton class="productcompactBuyButton" v-if="loaded" @gtag="gtag" ref="buybutton"></buybutton>   
    </div>
    <selectversion v-if="!$root.sub && admin  && !oldurl"  :prices="prices" ></selectVersion>
    <ProductPicker v-if="$root.sub" :admin="admin" :localadmin="localadmin" :oldurl="oldurl" ></ProductPicker>
  </div>
</template>

<script>
  import buybutton from './components/buybutton'
  import additionalInfo from './components/additionalInfo'
  import ProductPicker from './productPicker'
  import selectversion from './components/selectversion.vue';
  import PromotionLabel from './components/promotionlabel.vue'

  var priceHandler = require('../../globalComponents/visualFormattingForPrices');
  
  export default {
    name: "BuyButtonCompact",
    components: {
      buybutton,
      additionalInfo,
      ProductPicker,
      selectversion,
      PromotionLabel
    },
    data() {
      return {
        id: this.$root.id,
        prices: '',
        quantity: '',
        loaded: false,
        currencyType: '',
        availability: 0,
        tax: '',
        hidePrice: this.$root.hideprice,
        admin: this.$root.isAdmin,
        product:this.$root.productdata,
        localadmin:this.$root.isLocalAdmin,
        oldurl:""
      };
    },
    mounted() {
      var _that = this;
      this.entry = false;
      axios.get(window.basedir + "/ajaxRequestServlet?mode=GetProduct&isSpecial=true&payload={productID:" + this.id + ", isPointShop: " + this.$root.pointshop + "}", {
        headers: {
          'Content-type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': '0',
        }
      }).then((response) => {
        if (response.data?.errorMessage?.length > 0) {
          alertify.logPosition("bottom right").closeLogOnClick(true).delay(0).error('<i style="color:#ff7070 !important;padding-right: 3px;" class="fa fa-exclamation-triangle" aria-hidden="true"></i>  ' + response.data.errorMessage);
        }else {
          this.oldurl = document.querySelectorAll(".productImg")[0].getAttribute('data-oldurl');
          this.prices = response.data.products[0];
          this.tax = response.data.products[0].taxRateFactor;
          this.quantity = response.data.products[0].quantityString;
          this.currencyType = response.data.products[0].CurrencyIso;
          this.availability = parseInt(response.data.products[0].availability);
          this.loaded = true; 
          if(document.body.classList.contains("nutriverse")){
            // Define JSONLD Structured data markup for our product page   
            const jsonld_nutri = {
                "@context": "http://schema.org",
                "@type": "Product",
                "description": removeHtmlTags(`${this.prices.description}`),
                "name": `${this.prices.productName}`,
                "image": `${this.prices.imageUrl}`,
                "sku": `${this.prices.sku}`,
                "brand": {
                    "@type": "Brand",
                    "name": "Pharma Nord"
                },
                "mpn": "",
                "offers": {
                    "@type": "Offer",
                    "availability": `${this.prices.availability}` == 5 ? 'http://schema.org/InStock' : 'http://schema.org/OutOfStock',
                    "price": this.prices.price,
                    "priceCurrency": `${this.prices.CurrencyIso}`,
                    "url": this.href,     
                    "shippingDetails": {
                      "@type": "OfferShippingDetails",
                      "deliveryTime": {
                        "@type": "ShippingDeliveryTime",                      
                        "transitTime": {
                          "@type": "QuantitativeValue",
                          "value": 2,                        
                          "unitCode": "DAY"
                        }
                      }
                    }             
                          
                }
            }  
            //remove html tags from the description 
            function removeHtmlTags(string) {
                // Create a new element and set the string as its innerHTML
                var div = document.createElement("div");
                div.innerHTML = string;

                // Get the text content without HTML tags
                var cleanString = div.textContent || div.innerText;            

                //remove new line and double spaces
                var newCleanString = cleanString.replace(/\n/g, "").replace(/\s{2,}/g, " ");

                // Remove the created element
                div.remove();
                return newCleanString;
            }          
            //Inject JSONLD tag in the head
            const script = document.createElement('script');
            script.setAttribute('type', 'application/ld+json');          
            script.textContent = JSON.stringify(jsonld_nutri); 
            document.head.appendChild(script);
          }
        }
      });
    },
    methods: {
      showProductImagesOnClick: function() {
        var old_version = false;
        const event = new CustomEvent('triggerSku', {detail:{ sku1: this.prices.sku_no, trigger: true, src: this.prices.imageUrl, oldVersion:old_version}});
        window.dispatchEvent(event);
      },
      addToBasket: function() {
        var _that = this;
        this.entry = false;
        axios.get(window.basedir + '/ajaxRequestServlet?mode=UpdateQuantity&payload={"products":[{productID:' + this.id + ',quantity:1}], isPointShop: ' + this.$root.pointshop + '}', {
          headers: {
            'Content-type': 'application/json',
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': '0',
          }
        }).then((response) => {
          if (response.data.errorMessage.length > 0) {
            alertify.logPosition("bottom right").closeLogOnClick(true).delay(0).error('<i style="color:#ff7070 !important;padding-right: 3px;" class="fa fa-exclamation-triangle" aria-hidden="true"></i>  ' + response.data.errorMessage);
          } else {
            window.ajaxBasket.refresh();
          }
        });
      },
      gtag: function() {
            gtag('event', 'add_to_cart', {
            "items": [{
              'item_name': this.$root.productname,
              'item_id': this.id,
              'price': this.prices.price
            }]
          });
          if(window.hasFbq) {
            fbq('track', 'AddToCart', {
              content_ids: [this.id],
              content_name: this.$root.productname,
              currency: this.prices.CurrencyIso,
              value: this.prices.price
            });
          }
      },
      getVisString: function(money) {
        return priceHandler.default.visualFormattingForPrices(money, this.prices.CurrencyIso, this.prices.currencyPrecision, this.prices.locale)
      }
    },
    computed: {
      strippedQuant: function() {
        return this.quantity.replace(/<[^>]*>?/gm, '');
      },
      locale: function() {
        return window.locale.replace('_', '-');
      },
      href: function(){
        return window.location.href
      }   
    }
  }
</script>

<style lang="scss" scoped>
  .productcompact{ 
    display: flex; 
    justify-content: space-between;
    align-items: center;
    align-content: center;
    cursor: pointer;


    .priceWrap {
      margin-top: 0px !important;
      //float: left;
      //margin-top: 5px;     
    }
    &:hover {
      background-color: #c7edb5;
    }
   
  }
  .productprice p {
    span {
      color: #004570;
    }
  }
  .showVersions{
    width: auto;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    background-color: #7caf63;
    border: 1px solid #7caf63;
    border-radius: 10px;
    margin: 5px 0px;
    padding: 5px 20px;
    .select{
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      select{
        text-decoration: none;
        border:1px solid #7caf63;
        border-radius: 6px;
        width:60px;
        margin-left: 5px;
      }
    }
    .comments{
      display: flex;
      flex-direction: row;
      p{
       margin-left: 5px; 
      }
    }
  }

  .productprice p {
    span {
      color: #004570;
    }   
  }

  .productcompactBuyButton {
    margin-top: 0px !important;
  }

.productDetailHeaderContainer .productcompactWhite {
  min-height: 32px;
}
.btn_oldVersion{
  width: 125px;
	display: flex;
	flex-direction: row;
	justify-content: space-around;
	text-decoration: none;
	border: none;
	text-align: center;
	margin:  auto;
	padding: 5px;
	background-color: #7caf63;
	border-radius: 10px;
}
.btn_oldVersion input{
	border-radius: 8px;
	text-decoration: none;
	border: none;
  text-align: center;
}
.btn_oldVersion select{
  border-radius: 2px;
  text-decoration: none;
  border: none;
  text-align: center;
}
</style>